// ResizeGrip.jsx — the shared column-resize grip for table headers (Positions / Orders / MW).
// Renders the thin grab strip on a header's right edge AND owns the drag-to-resize logic,
// so no table duplicates it. Live width updates flow up via onResize(key, px);
// the page's useColumnLayout owns the layout + persistence.
//
//   {onColumnResize && <ResizeGrip colKey={col.key} width={col.width} onResize={onColumnResize} />}
import React from 'react';

const MIN_WIDTH = 34;

export default function ResizeGrip({ colKey, width, onResize }) {
  function startResize(e) {
    e.preventDefault();
    e.stopPropagation();
    const startX = e.clientX;
    const startWidth = width || 60;
    const onMove = (ev) => onResize(colKey, Math.max(MIN_WIDTH, Math.round(startWidth + (ev.clientX - startX))));
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }

  return (
    <span onMouseDown={startResize} title="Drag to resize"
      style={{ position: 'absolute', top: 0, right: 0, width: 6, height: '100%', cursor: 'col-resize' }} />
  );
}
